var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-collapse-transition',[_c('canvas',{directives:[{name:"show",rawName:"v-show",value:(_vm.state.rulerVisible),expression:"state.rulerVisible"}],ref:"canvas",style:({
      transition: '.3s all',
      background: 'rgba(0,0,0,.7)',
      position: 'absolute',
      left: '0',
      top: '0'
    })},[_vm._v("您的浏览器不支持canvas 请使用最新版浏览器")])])}
var staticRenderFns = []

export { render, staticRenderFns }